<template>
   <div class="shift-report-print-temp-2 receipt-thermal" :dir="$vuetify.rtl ? 'rtl' : 'ltr'">
      <!-- 1. بيانات الوردية -->
      <div class="receipt-section">
         <div class="receipt-row">
            <span class="receipt-value">{{ report.start_date || '—' }}</span>
            <span class="receipt-dots"></span>
            <span class="receipt-label">{{ $t('start date') }}</span>
         </div>
         <div class="receipt-row">
            <span class="receipt-value">{{ report.end_date || '—' }}</span>
            <span class="receipt-dots"></span>
            <span class="receipt-label">{{ $t('end date') }}</span>
         </div>
         <div class="receipt-row">
            <span class="receipt-value">{{ report.branch_name || '—' }}</span>
            <span class="receipt-dots"></span>
            <span class="receipt-label">{{ $t('branch') }}</span>
         </div>
         <div class="receipt-row">
            <span class="receipt-value">{{ report.user_full_name || '—' }}</span>
            <span class="receipt-dots"></span>
            <span class="receipt-label">{{ $t('employee') }}</span>
         </div>
      </div>

      <!-- 2. الملخص المالي -->
      <div class="receipt-section">
         <div class="receipt-row">
            <span class="receipt-value">{{ report.total_sales || 0 | nonZero }}</span>
            <span class="receipt-dots"></span>
            <span class="receipt-label">{{ $t('total sales') }}</span>
         </div>
         <div class="receipt-row">
            <span class="receipt-value">{{ report.total_sales_cash || 0 | nonZero }}</span>
            <span class="receipt-dots"></span>
            <span class="receipt-label">{{ $t('sales cash') }}</span>
         </div>
         <div class="receipt-row">
            <span class="receipt-value">{{ report.total_sales_master || 0 | nonZero }}</span>
            <span class="receipt-dots"></span>
            <span class="receipt-label">{{ $t('master card') }}</span>
         </div>
         <div class="receipt-row">
            <span class="receipt-value">{{ report.total_sales_visa || 0 | nonZero }}</span>
            <span class="receipt-dots"></span>
            <span class="receipt-label">{{ $t('visa') }}</span>
         </div>
         <div class="receipt-row">
            <span class="receipt-value">{{ report.total_sales_mada || 0 | nonZero }}</span>
            <span class="receipt-dots"></span>
            <span class="receipt-label">{{ $t('mada') }}</span>
         </div>
         <div class="receipt-row">
            <span class="receipt-value">{{ report.total_sales_other || 0 | nonZero }}</span>
            <span class="receipt-dots"></span>
            <span class="receipt-label">{{ $t('other') }}</span>
         </div>
         <div class="receipt-row">
            <span class="receipt-value">{{ report.total_nd || 0 | nonZero }}</span>
            <span class="receipt-dots"></span>
            <span class="receipt-label">{{ $t('notice debtor') }}</span>
         </div>
         <div class="receipt-row">
            <span class="receipt-value">{{ report.total_nc || 0 | nonZero }}</span>
            <span class="receipt-dots"></span>
            <span class="receipt-label">{{ $t('notice creditor') }}</span>
         </div>
         <div class="receipt-row">
            <span class="receipt-value">{{ report.total_expenses || 0 | nonZero }}</span>
            <span class="receipt-dots"></span>
            <span class="receipt-label">{{ $t('expenses') }}</span>
         </div>
         <div class="receipt-row">
            <span class="receipt-value">{{ report.diff_cash || 0 | nonZero }}</span>
            <span class="receipt-dots"></span>
            <span class="receipt-label">{{ $t('difference cash') }}</span>
         </div>
         <div class="receipt-row">
            <span class="receipt-value">{{ calculatedTotals.total_network || 0 | nonZero }}</span>
            <span class="receipt-dots"></span>
            <span class="receipt-label">{{ $t('difference network') }}</span>
         </div>
      </div>

      <!-- 3. جدول طرق الدفع -->
      <div class="receipt-section">
         <div class="receipt-table-header receipt-payment-header">
            <span class="col-method">{{ $t('payment method') }}</span>
            <span class="col-open">{{ $t('start') }}</span>
            <span class="col-close">{{ $t('end') }}</span>
            <span class="col-delta">{{ $t('deficit surplus') }}</span>
         </div>
         <div v-for="(pm, idx) in paymentMethodsList" :key="idx" class="receipt-payment-row">
            <span class="col-method">{{ pm.name_ar || pm.name_en || pm.name || $t(pm.key || '') }} {{ pm.sar ? '(SAR)' :
               '' }}</span>
            <span class="col-open">{{ (pm.open != null ? pm.open : 0) | nonZero }}</span>
            <span class="col-close">{{ (pm.close != null ? pm.close : 0) | nonZero }}</span>
            <span class="col-delta">
               <template v-if="Number(pm.delta) === 0">
                  {{ $t('matching') }} {{ 0 | nonZero }}
               </template>

               <template v-else-if="Number(pm.delta) < 0">
                  {{ $t('deficit') }} {{ Math.abs(Number(pm.delta)) | nonZero }}
               </template>

               <template v-else>
                  {{ $t('surplus') }} {{ Number(pm.delta) | nonZero }}
               </template>
            </span>
         </div>
      </div>

   </div>
</template>

<script>
export default {
   name: "ShiftsPrintTemp2",
   props: {
      report: {
         type: Object,
         default: () => ({})
      },
      printStaticData: {
         type: Object,
         default: () => ({})
      }
   },
   computed: {
      calculatedTotals() {
         const r = this.report || {};
         if (Object.keys(r).length) {
            const total_network = (r.diff_visa || 0) + (r.diff_master || 0) + (r.diff_mada || 0) + (r.diff_other || 0);
            return { total_network };
         }
         return { total_network: 0 };
      },
      paymentMethodsList() {
         const report = this.report || {};
         const list = report.payment_methods;
         if (Array.isArray(list) && list.length) {
            return list.map((pm) => ({
               name_ar: pm.name_ar,
               name_en: pm.name_en,
               name: pm.name,
               key: pm.key,
               open: pm.open,
               close: pm.close,
               delta: pm.delta,
               status: pm.status,
               sar: pm.sar !== false
            }));
         }
         const r = report;
         const build = (key, nameAr, nameEn, open, close, delta) => {
            const d = Number(delta || 0);
            return {
               key,
               name_ar: nameAr,
               name_en: nameEn,
               open: open != null ? open : 0,
               close: close != null ? close : 0,
               delta: d,
               status: d === 0 ? 'matching' : (d < 0 ? 'deficit' : 'surplus'),
               sar: true
            };
         };
         return [
            build('cash', 'كاش', 'CASH', r.start_cash, r.end_cash, r.diff_cash),
            build('network', 'شبكة', 'SPAN', 0, 0, (r.diff_visa || 0) + (r.diff_master || 0) + (r.diff_mada || 0) + (r.diff_other || 0)),
            build('visa', 'فيزا', 'VISA', 0, r.end_visa, r.diff_visa),
            build('master card', 'ماستر كارد', 'MASTER CARD', 0, r.end_master, r.diff_master),
            build('mada', 'مدى', 'MADA', 0, r.end_mada, r.diff_mada),
            build('other', 'أخرى', 'Other', 0, r.end_other, r.diff_other)
         ].filter(Boolean);
      }
   }
};
</script>

<style lang="scss" scoped>
.shift-report-print-temp-2.receipt-thermal {
   font-family: 'Courier New', Courier, monospace;
   font-size: 11px;
   max-width: 320px;
   margin: 0 auto;
   padding: 8px;
   line-height: 1.35;
   color: #000;

   .receipt-section {
      margin-bottom: 10px;
      border-bottom: 1px dashed #999;
      padding-bottom: 6px;
   }

   .receipt-section:last-child {
      border-bottom: none;
   }

   .receipt-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 2px;
      min-height: 18px;
   }

   .receipt-label {
      flex-shrink: 0;
      white-space: nowrap;
      text-align: right;
   }

   .receipt-value {
      flex-shrink: 0;
      text-align: left;
   }

   .receipt-dots {
      flex: 1;
      min-width: 8px;
      margin: 0 4px;
      border-bottom: 1px dotted #666;
      align-self: flex-end;
      margin-bottom: 3px;
   }

   .receipt-table-header,
   .receipt-payment-header {
      display: flex;
      justify-content: space-between;
      font-weight: bold;
      padding: 4px 0;
      border-bottom: 1px solid #333;
      margin-bottom: 2px;
      font-size: 10px;
   }

   .receipt-payment-row {
      display: flex;
      justify-content: space-between;
      padding: 2px 0;
      border-bottom: 1px dotted #ccc;
      font-size: 10px;
   }

   .receipt-payment-row .col-method,
   .receipt-payment-header .col-method {
      flex: 1 1 35%;
      text-align: right;
      padding-left: 4px;
   }

   .receipt-payment-row .col-open,
   .receipt-payment-header .col-open {
      flex: 0 0 50px;
      text-align: left;
   }

   .receipt-payment-row .col-close,
   .receipt-payment-header .col-close {
      flex: 0 0 50px;
      text-align: left;
   }

   .receipt-payment-row .col-delta,
   .receipt-payment-header .col-delta {
      flex: 0 0 72px;
      text-align: left;
   }

   .col-total {
      flex: 0 0 50px;
      text-align: left;
   }

   &[dir="rtl"] {

      .receipt-value,
      .col-delta,
      .col-close,
      .col-open,
      .col-total {
         text-align: right;
      }

      .receipt-label,
      .col-method {
         text-align: left;
      }
   }
}
</style>
